import { Component, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, ValidationErrorSettings } from "../../../../../services/validators/product-validator.service";

@Component({
  selector: 'app-ape-paypal-code',
  templateUrl: './ape-paypal-code.component.html',
  styleUrls: ['./ape-paypal-code.component.scss']
})
export class ApePaypalCodeComponent extends FormComponent implements OnInit {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }

  constructor(
    private _productValidator:ProductValidatorService,
  ) { super() }

   ngOnInit() { 
    let validationErrorSettings:ValidationErrorSettings = {fieldNameForMessage:'Paypal Code', required:false, minlength:5}
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationErrorSettings);

  }


}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-paypal-code/ape-paypal-code.component.ts